import api from './api'

/**
 * Serviço de Campanhas (Ciclos de Avaliação)
 */
export default {
  /**
   * Listar campanhas
   */
  list(params = {}) {
    return api.get('/api/campaigns', { params })
  },

  /**
   * Criar campanha
   */
  create(campaignData) {
    return api.post('/api/campaigns', campaignData)
  },

  /**
   * Obter campanha por ID
   */
  getById(id) {
    return api.get(`/api/campaigns/${id}`)
  },

  /**
   * Atualizar campanha
   */
  update(id, campaignData) {
    return api.put(`/api/campaigns/${id}`, campaignData)
  },

  /**
   * Lançar campanha
   */
  launch(id) {
    return api.post(`/api/campaigns/${id}/launch`)
  },

  /**
   * Excluir campanha
   */
  delete(id) {
    return api.delete(`/api/campaigns/${id}`)
  },

  /**
   * Duplicar campanha
   */
  duplicate(id) {
    return api.post(`/api/campaigns/${id}/duplicate`)
  },

  /**
   * Disparar notificações por e-mail
   */
  notifyEmail(id) {
    return api.post(`/api/campaigns/${id}/notify-email`)
  },

  /**
   * Disparar notificações via Teams
   */
  notifyTeams(id) {
    return api.post(`/api/campaigns/${id}/notify-teams`)
  },

  /**
   * Marcar campanha como concluída
   */
  complete(id) {
    return api.post(`/api/campaigns/${id}/complete`)
  },

  /**
   * Obter estatísticas da campanha
   */
  getStats(id) {
    return api.get(`/api/campaigns/${id}/stats`)
  },

  /**
   * Tracking pixel
   */
  getTrackingPixel(id) {
    return api.get(`/api/campaigns/${id}/track/pixel.png`, {
      responseType: 'blob',
    })
  },
}
